/* Datum & Ink — turning the gallery from wall to wall.

   Clicking a side wall turns the room to face it. Click, not hover: a hover
   swap fired on every pass of the cursor, which made the room twitch while you
   were only on your way to the buttons underneath it, and gave no way to stay
   on a wall and look at it.

   Every view is the same drawn box with a different hang, so the turn is two
   flat images passing each other rather than a camera move the browser has to
   solve. The 90-degree swing is sold by translating and shearing the whole
   room out to one side and bringing the next one in from the other — which is
   what a real quarter turn looks like from a fixed standpoint.

   The active view is published on the root as data-view so the CSS, the live
   product and anything added later can all read one piece of state. */
(function () {
  // Which wall each side zone is SHOWING, per view — which is therefore the
  // wall that zone turns to. Mirrors VIEWS in storefront/hero_gallery.py; keep
  // the two in step, or a zone will turn to a wall other than the one it
  // displays. (Fixed per-zone targets were wrong once you could stay on a side
  // wall: from the left view, the right-hand zone shows the back wall.)
  var NEIGHBOUR = {
    back:  { left: 'left',  right: 'right' },
    left:  { left: 'right', right: 'back'  },
    right: { left: 'back',  right: 'left'  }
  };

  var HALF = 300;    // ms for each half of the turn
  var GRACE = 120;   // ms the timers allow the animation to land on its own

  function paint(root, view) {
    root.dataset.view = view;

    var rooms = root.querySelectorAll('.di-hero__room');
    for (var i = 0; i < rooms.length; i++) {
      rooms[i].classList.toggle('is-on', rooms[i].dataset.view === view);
    }

    // The label has to follow the view, not the zone, for the same reason the
    // target does.
    var tpl = root.dataset.turnLabel || 'Turn to face the {wall} wall';
    var zones = root.querySelectorAll('.di-hero__zone');
    for (var j = 0; j < zones.length; j++) {
      var to = NEIGHBOUR[view] && NEIGHBOUR[view][zones[j].dataset.side];
      zones[j].setAttribute('aria-label', tpl.replace('{wall}', to || ''));
    }
  }

  function turn(root, side) {
    if (root.dataset.turning === '1') return;

    var from = root.dataset.view;
    var to = NEIGHBOUR[from] && NEIGHBOUR[from][side];
    if (!to || to === from) return;

    var wrap = root.querySelector('.di-hero__turn');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // document.hidden matters because a hidden document's animation timeline is
    // frozen: the turn would start, hold the room at opacity 0 and never land.
    if (!wrap || reduced || document.hidden || typeof wrap.animate !== 'function') {
      paint(root, to);
      return;
    }

    // Clicking a wall brings THAT wall to the centre, so the scene travels
    // toward the opposite side: click left, everything slides right.
    var dir = side === 'left' ? 1 : -1;
    var away = 'translateX(' + (dir * 16) + '%) rotateY(' + (dir * -24) + 'deg) scale(1.06)';
    var toward = 'translateX(' + (dir * -16) + '%) rotateY(' + (dir * 24) + 'deg) scale(1.06)';

    root.dataset.turning = '1';

    // Both halves are sequenced on timers, with the animations' own onfinish as
    // the fast path. The animation cannot be the source of truth: pausing the
    // timeline (backgrounding the tab mid-turn) would strand data-turning at 1
    // forever, which leaves the room invisible and both walls unclickable.
    // Timers keep running when the compositor does not.
    var out = wrap.animate(
      [{ transform: 'none', opacity: 1 }, { transform: away, opacity: 0 }],
      { duration: HALF, easing: 'cubic-bezier(.4,0,.9,.45)', fill: 'forwards' });

    var back = null;
    var swapped = false;
    var landed = false;

    function land() {
      if (landed) return;
      landed = true;
      // Cancelling drops the forwards fill, returning the wrapper to its own
      // styles — which are already the resting state.
      out.cancel();
      if (back) back.cancel();
      root.dataset.turning = '0';
    }

    function swap() {
      if (swapped) return;
      swapped = true;
      // Swap at the far end of the swing, while the room is off screen.
      paint(root, to);
      back = wrap.animate(
        [{ transform: toward, opacity: 0 }, { transform: 'none', opacity: 1 }],
        { duration: HALF, easing: 'cubic-bezier(.1,.55,.3,1)', fill: 'forwards' });
      back.onfinish = land;
      setTimeout(land, HALF + GRACE);
    }

    out.onfinish = swap;
    setTimeout(swap, HALF + GRACE);
  }

  function init(root) {
    if (root.dataset.diViewReady === '1') return;
    root.dataset.diViewReady = '1';

    var zones = root.querySelectorAll('.di-hero__zone');
    for (var i = 0; i < zones.length; i++) {
      (function (zone) {
        zone.addEventListener('click', function () {
          turn(root, zone.dataset.side);
        });
      })(zones[i]);
    }

    paint(root, root.dataset.view || 'back');
  }

  function boot() {
    var nodes = document.querySelectorAll('.di-hero');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
